import { Flex } from "@/atoms"

import type { WidgetTemplateProps } from "."

export const WidgetTemplate = (props: WidgetTemplateProps) => {
  const { children, componentProps, Component, verticalGap = 14 } = props

  return (
    <Flex flex={1} gap={40}>
      <Flex vertical flex={1} gap={verticalGap}>
        {children}
      </Flex>
      <Flex flex={2} align="flex-end">
        {Component && <Component {...componentProps} />}
      </Flex>
    </Flex>
  )
}
